import { Controller } from '@hotwired/stimulus';
import { getCountryNameByCode } from './utils';
/*
 * Description
 * -------
 *
 * Renders the shipping address.
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Usage
 * -------
 *
 * <div
 *   data-controller="shipping-address-render"
 *   data-shipping-address-render-name-value="..."
 *   data-shipping-address-render-address1-value="..."
 *   data-shipping-address-render-address2-value="..."
 *   data-shipping-address-render-city-value="..."
 *   data-shipping-address-render-country-value="..."
 *   data-shipping-address-render-state-value="..."
 * ></div>
 */
export default class default_1 extends Controller {
    static values = {
        name: { type: String, default: '' },
        address1: { type: String, default: '' },
        address2: { type: String, default: '' },
        city: { type: String, default: '' },
        country: { type: String, default: '' },
        state: { type: String, default: '' },
        zip: { type: String, default: '' },
        phone: { type: String, default: '' },
        vatId: { type: String, default: '' },
    };
    connect() {
        this.element.innerHTML = `
      <p>${this.nameValue}</p>
      <p>${this.address1Value}</p>
      ${this.address2Value && `<p>${this.address2Value}</p>`}
      <p>${this.cityValue}${this.stateValue ? `, ${this.stateValue}` : ''}${this.zipValue ? `, ${this.zipValue}` : ''}</p>
      <p>${getCountryNameByCode(this.countryValue)}</p>
      ${this.phoneValue && `<p>${this.phoneValue}</p>`}
      ${this.vatIdValue && `<p>${this.vatIdValue}</p>`}
    `;
    }
    documentMorph() {
        this.connect();
    }
}
